/**
 * Pointer capability detection — MOVE-05.
 *
 * HARD RULE: zero user-agent sniffing. UA sniffing breaks on iPad (reports
 * "Macintosh"), desktops with touchscreens, and dev-tool emulators. Instead we
 * test capability: matchMedia('(pointer: coarse)') + navigator.maxTouchPoints.
 */

export type PointerType = 'coarse' | 'fine'

/**
 * Returns 'coarse' when the primary pointer is touch-class (phones, most tablets),
 * or when the device has any touch points at all (iPad+keyboard hybrid; Pitfall 5).
 * Returns 'fine' only when both signals agree there is no touch surface.
 */
export function detectPointer(): PointerType {
  const coarseMQ = window.matchMedia('(pointer: coarse)')
  const hasTouch = navigator.maxTouchPoints > 0
  return coarseMQ.matches || hasTouch ? 'coarse' : 'fine'
}

/**
 * Subscribe to pointer-capability changes (e.g. user plugs in a keyboard).
 * Returns an unsubscribe function.
 */
export function onPointerChange(cb: (t: PointerType) => void): () => void {
  const mq = window.matchMedia('(pointer: coarse)')
  const handler = () => cb(detectPointer())
  mq.addEventListener('change', handler)
  return () => mq.removeEventListener('change', handler)
}
